// 用户页
const user = () => import(/* webpackChunkName: "Index" */ '@/views/userModule/index');
//主播管理
const AnchorManagement = () => import(/* webpackChunkName: "Index" */ '@/views/userModule/AnchorManagement');
// 副播管理
const assistantAnchor = () =>import("@/views/matchAreaController/assistantAnchor/AnchorManagement");
const userRouter = [
  {
    path: '/index',
    redirect: '/admin/home',
    component: () => import('@/views/loginModule/index'),
    children: [
      {
        path: '/admin/user',
        name: 'user',
        component: user,
        meta: {
          title: '用户管理'
        }
      },
      {
        path: '/admin/AnchorManagement',
        name: 'AnchorManagement',
        component: AnchorManagement,
        meta: {
          title: '主播管理'
        }
      },
      {
        path: '/admin/assistantAnchor',
        name: 'assistantAnchor',
        component: assistantAnchor,
        meta: {
          title: '副播管理'
        }
      }
    ]
  }
]
export default userRouter

